import { withCurrentParams } from 'actions/utils';
import { BROADCAST_SAVE_RECORDING_AS_MEDIA_SOURCE } from '@shoflo/studio-redux/actions/types';
import { getSignedUrl } from 'utils/broadcastSourceHelper';
import { SOURCE_CREATE } from 'store/eventConstants';
import { showNotification } from '@shoflo/studio-redux/actions';

export default recordingId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        meeting: { attendeeResponse }
      } = getState();
      const action = {
        type: BROADCAST_SAVE_RECORDING_AS_MEDIA_SOURCE,
        request: async apiClient => {
          try {
            let response = await apiClient.broadcast.saveRecordingAsSource(
              teamId,
              eventId,
              broadcastId,
              recordingId
            );

            response = await getSignedUrl(response, apiClient);

            socket.emit(SOURCE_CREATE, {
              broadcastId,
              notifyingDirector:
                attendeeResponse && attendeeResponse.Attendee.AttendeeId
            });

            return response;
          } catch (error) {
            console.log('Failed to save recording as media source' + error);
            dispatch(
              showNotification('Failed to save recording as media source', {
                type: 'warning'
              })
            );
            throw error;
          }
        }
      };
      dispatch(action);
    }
  );
};
